// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__JYldI","containerItemsCenter":"Skeleton_containerItemsCenter__SY7tQ"};